import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import { BgSingleComponent } from "@banggood/scm-fe";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  // 加入我们
  {
    path: "/joinUs",
    name: "joinUs",
    component: () => import("../views/join-us/index.vue"),
  },
  {
    path: "/joinUs/activation",
    name: "joinUsActivation",
    component: () => import("../views/join-us/active/index.vue"),
  },
  {
    path: "/capacity",
    name: "capacity",
    component: () => import("../views/capacity/index.vue"),
  },
  {
    path: "/addNewProduct",
    name: "addNewProduct",
    component: () => import("../views/newProduct/add/index.vue"),
  },
  {
    path: "/newProduct/:id",
    name: "newProductDetail",
    component: () => import("../views/newProduct/detail/index.vue"),
  },
  {
    path: "/component/:componentName",
    name: "Component",
    component: BgSingleComponent,
    props: {
      components: [
        {
          name: "encasementDialog",
          component: () =>
            import("@/views/deliveryOrder/encasement/dialog.vue"),
          isDialog: true,
        },
        // {
        //   name: "modifyDeliveryDate",
        //   component: () =>
        //     import(
        //       "@/views/product-info/components/modify-delivery-date/index.vue"
        //     ),
        // },
        // {
        //   name: "supplierCreator",
        //   component: () => import("@/components/supplier-creator/index.vue"),
        // },
        {
          name: "wmsPrintPdf",
          component: () => import("@/components/wmsPrintPdf/index.vue"),
        },
        {
          name: "wmsPrintPdfGuides",
          component: () => import("@/components/wmsPrintPdf/guides/index.vue"),
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
